export const FLOW_RUN_NOW_EVENT = 'flownotes:flow-run-now'
export const FLOW_OPEN_TAB_EVENT = 'flownotes:flow-open-tab'
export const FLOW_OPEN_SURFACE_EVENT = 'flownotes:flow-open-surface'

export type FlowDocTab = 'definition' | 'runs'
export type FlowStudioSurface = 'pulse' | 'gallery' | 'sources' | 'composer'

export const FLOW_STUDIO_SURFACE_LABEL: Record<FlowStudioSurface, string> = {
  pulse: 'Pulse',
  gallery: 'Gallery',
  sources: 'Sources',
  composer: 'Composer',
}

export function flowStudioTabId(surface: FlowStudioSurface) {
  return `flow-studio:${surface}`
}

export function flowStudioSurfaceFromTabId(id: string | null | undefined): FlowStudioSurface | null {
  if (!id?.startsWith('flow-studio:')) return null
  const surface = id.slice('flow-studio:'.length)
  if (surface === 'pulse' || surface === 'gallery' || surface === 'sources' || surface === 'composer') {
    return surface
  }
  return null
}

export function openFlowStudioSurface(surface: FlowStudioSurface) {
  window.dispatchEvent(new CustomEvent(FLOW_OPEN_SURFACE_EVENT, { detail: { surface } }))
}

export function flowTabStorageKey(flowId: string) {
  return `flow-studio-tab:${flowId}`
}

export function rememberFlowTab(flowId: string, tab: FlowDocTab) {
  try {
    sessionStorage.setItem(flowTabStorageKey(flowId), tab)
  } catch {
    /* private mode */
  }
}

export function readFlowTab(flowId: string): FlowDocTab {
  try {
    return sessionStorage.getItem(flowTabStorageKey(flowId)) === 'runs' ? 'runs' : 'definition'
  } catch {
    return 'definition'
  }
}
